export default abstract class WindowEvent extends Event {
    // skipcq: JS-0358
    constructor(type: string, eventInitDict?: EventInit | undefined) {
        super(type, eventInitDict);
    }

    protected static addListenerToWindow<E extends WindowEvent>(type: string, callback: (event: E) => void): void {
        window.addEventListener(type, callback as EventListener);
    }

    protected static removeListenerFromWindow<E extends WindowEvent>(type: string, callback: (event: E) => void): void {
        window.removeEventListener(type, callback as EventListener);
    }

    protected static dispatchEvent<E extends WindowEvent>(event: E): void {
        window.dispatchEvent(event);
    }
}
